import React from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import products from "./data/combinedData";
import "./ProductDetail.css";
import logo from "./Images/aman logo.png";
import { FaWhatsapp } from "react-icons/fa";

function ProductDetail() {
    const { slug } = useParams();
    const location = useLocation();

    const normalize = (str) =>
        (str || "").toLowerCase().trim().replace(/\s+/g, " ");

    const [rawName, ...casParts] = decodeURIComponent(slug || "").split("-");
    const decodedName = normalize(rawName);
    const decodedCAS = casParts.join("-");

    const product = products.find(
        (p) =>
            normalize(p.productName) === decodedName &&
            normalize(p.casNumber) === normalize(decodedCAS)
    );

    if (!product) {
        return <p className="error">❌ Invalid product link or product not found.</p>;
    }

    const whatsappMessage = `Hello, I am interested in this product:\n\nProduct Name: ${product.productName}\nCAS Number: ${product.casNumber}`;

    const backLink = location.state?.backTo || "/our-products";

    return (
        <div className="product-detail-wrapper">
            <div className="product-card">
                <div className="product-header">
                    <h2 className="product-title">{product.productName}</h2>
                    <img src={logo} alt="Logo" className="product-logo" />
                </div>

                <div className="product-field1">
                    <span className="field-label">CAS Number:</span>
                    <span className="field-value">{product.casNumber}</span>
                </div>

                <div className="product-field">
                    <span className="field-label">Description:</span>
                    <span className="field-value">{product.description}</span>
                </div>

                <div className="product-actions">
                    <a
                        href={`https://wa.me/917405649537?text=${encodeURIComponent(whatsappMessage)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="whatsapp-button"
                    >
                        <FaWhatsapp className="wa-icon" /> Enquire on WhatsApp
                    </a>

                    <Link to={backLink} className="back-button">
                        ← Back to Products
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default ProductDetail;
